// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__6jtlY","title":"ErrorPage_title__c9Qrl","descr":"ErrorPage_descr__T5_tv","help":"ErrorPage_help__JY8_L","link":"ErrorPage_link__KfPYL"};